import axios from "axios";
import { BASE_URL, SUB_URL } from "./BaseUrl";

const ManageGarmentService = {

  getGarmentBybinId: async (bin_id) => {
    try {
      const formData = new FormData();
      formData.append("bin_id", bin_id);

      const response = await axios.post(
        `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.view_bin}`,
        formData
      );

        return response.data;

    } catch (error) {
      console.error('Error fetching garment by bin ID:', error);
    }
  },

  deleteKanbanbyDbd_id: async (dbd_id) => {
    try {
      const response = await axios.get(
        `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.deleteKanbanByDbdid}?dbd_id=${dbd_id}`
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting kanban by dbd_id:', error);
    }
  },

  editKanban: async (size, editValue) => {
    console.log("editValue", editValue);
    console.log("size", size);

    try {
      const formData = new FormData();
      formData.append("dbd_id", editValue[0].db_id);
      formData.append("total_qty", editValue[0].totalQty);
      formData.append("size_qty", size);

      const formDataEntries = Array.from(formData.entries());
      console.table(
        formDataEntries.map(([key, value]) => ({ Key: key, Value: value }))
      );

      const response = await axios.post(
        `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.editKanban}`,
        formData
      );
      return response.data;
    } catch (error) {
      console.error('Error in Updating data:', error);
    }
  },

  add_garment: async (kb_number) => {

    try {
      const formData = new FormData();
      formData.append("kb_number", kb_number);
      const response = await axios.post(
        `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.add_garment}`,
        formData
      );
      return response.data;
    } catch (error) {
      console.error('Error in Updating data:', error);
    }
  },

  add_garment_to_Bin: async (getKanbanData, userData, binId) => {

    console.log(getKanbanData[0].size_name);
    
    try {
      const formData = new FormData();
      formData.append('kanban_no', getKanbanData[0].kb_number);
      formData.append('size_qty', getKanbanData[0].size_name);
      formData.append('bin_id', binId);
      formData.append('added_by', userData.userdata.su_id);
      formData.append('total_qty', getKanbanData[0].tot_qty);

      const response = await axios.post(
        `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.add_garments}`,
        formData ,{
          headers: {
              'Content-Type': 'multipart/form-data',
          },
      }
      );
      console.log(response.data);
      
      return response.data;
    } catch (error) {
      console.error('Error in Updating data:', error);
    }
  },

};

export default ManageGarmentService;